module.exports = __webpack_public_path__ + "img/new.b0f03268.svg";